import { useWalkthroughModalStore } from "../../stores/walkthroughModalStore.ts";

const WalkthroughModal = () => {
  const { setShowWalkthroughModal } = useWalkthroughModalStore();

  return (
    <div className="fixed flex inset-0 z-50 items-center justify-center px-2">
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-xs"
        data-overlay
        onClick={() => setShowWalkthroughModal(false)}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            setShowWalkthroughModal(false);
          }
        }}
      />
      <div className="relative w-full max-w-2xs rounded-3xl bg-white shadow-2xl space-y-2 text-center ">
        <div className="w-full flex items-end justify-end">
          <button
            className="p-3"
            onClick={() => setShowWalkthroughModal(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M17 7L7 17M7 7L17 17"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        <div className="space-y-6 flex flex-col items-center px-2 pb-4">
          <div className="text-black font-bold text-xl">
            Smart Walkthrough Mode
          </div>
          <div className="text-[#43483E]">
            You're in auto-pilot mode — a 3D walkthrough that guides you through
            the home, room by room.
            <br />
            <br />
            Tap <strong>pause</strong> in the top right to take control and
            explore at your own pace.
            <br />
            Resume to jump back into the guided tour. Smooth. Seamless.
            Interactive.
          </div>
          <button
            type="button"
            onClick={() => setShowWalkthroughModal(false)}
            className="font-bold bg-z-prussian-blue text-white rounded-full py-3 px-4 flex items-center gap-2"
          >
            Start Viewing
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
            >
              <path
                d="M3.83301 7.99992H13.1663M13.1663 7.99992L8.49967 3.33325M13.1663 7.99992L8.49967 12.6666"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};
export { WalkthroughModal };
